import React,{useState,useEffect} from 'react';
import { GoogleMap, LoadScript,Polygon, Marker } from '@react-google-maps/api';
import { Typography ,Box, Paper, Card, IconButton} from '@material-ui/core';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {generaCoordenadaDinam} from '../funciones/Mapas/FormatoCoord'
import CancelIcon from '@material-ui/icons/Cancel';
import CajaLeyenda from './CajaLeyenda';

  let arreColores=["#038545", "#EF8012", "#347AF4", "#FFC107", "#119A4F", "#B406D8", "#FFA318", "#DC4A3D", "#32CA81", 
                    "#F9B546", "#ED0808", "#0097A7", "#880E4F", "#4BAC7D", "#C52363", "#F57F06", "#7C594C", "#DBE772"]

export default function MapaMarcadorSeccion({poligonos,centro ,cambiaMarcador,setCambiaMarcador,redimensionar,setCoordenada,listPoligono,listMapProm,listApoyos,listRecorrido, listComercio, checkEtiqSecc,setCheckEtiqSecc}){
  
  let altuTamMax=825
  let anchoTamMax=1535
  const [rutaPol, setRutaPol] = useState([]);
  const [seccPolEntrada, setSeccPolEntrada] = useState([]);
  const [autocomplete, setAutocomplete] = useState([]);    
  const [auxColores, setAuxColores] = useState(arreColores);
  const [alturaContenedor, setAlturaContenedor] = useState (
                                            (!redimensionar) ? (window.innerHeight<altuTamMax ? window.innerHeight-165: window.innerHeight - 200)
                                                             : (window.innerHeight<altuTamMax ? window.innerHeight-215: window.innerHeight - 250))
  const [anchoContenedor, setAnchoContenedor] = useState(
                                            (!redimensionar) ? window.innerWidth<anchoTamMax ? window.innerWidth-200 : window.innerWidth-300
                                                             : window.innerWidth<anchoTamMax ? window.innerWidth-510 : window.innerWidth-750)
  const [auxMarcador, setAuxMarcador] = useState([]);
  const [auxPoligRevision, setAuxPoligRevision] = useState([]);
  const [leyendaMap, setLeyendaMap] = useState([]);

  useEffect(()=>
  { 
    let seccionEntrada=[]    
    if (listPoligono.length>0) 
    {  
      try {
        let poligonoRevision=JSON.parse(listPoligono);  
        setAuxPoligRevision(poligonoRevision)       
        poligonoRevision.forEach((poligono) => {                  
          let auxCoord=generaCoordenadaDinam(poligono[1], poligono[0]) 
          seccionEntrada.push(auxCoord)                            
        })  
        setSeccPolEntrada(seccionEntrada);      
      } 
      catch (error) {        
        let mensaje2="Error en la cadena "+error                                         
        toast.error(mensaje2, 
        {   position: toast.POSITION.BOTTOM_RIGHT, 
            theme: "colored", autoClose: 10000, 
            containerId:'mapaSeccionPol'
        });
      }
      
    }
    else
    { 
      setSeccPolEntrada([])
      setAuxPoligRevision([])
    }

    if (poligonos)
    {      
      let ordenado=[]
      poligonos.forEach((poligono) => {
        let arr=[]
        poligono.gps.forEach((coorde)=>{
          let auxCoord=generaCoordenadaDinam(coorde.Lat, coorde.Lon) 
          arr.push(auxCoord)                 
        })
        const auxCentro=generaCoordenadaDinam(poligono.Lat, poligono.Lon) 
        ordenado.push({Id:poligono.Id,centro:auxCentro,secc:poligono.Num,gps:arr})      
      })
 
      setRutaPol(ordenado);

      let auxNumSecc = poligonos.length
      if (auxNumSecc > arreColores.length) 
      { let auxArregloColor=[] 
        for (let index = 0; index < auxNumSecc; index++) 
        { let nivel= (index % 18 === 0) ? (index / 18===1 ? 0 :17): (index % 18)
          auxArregloColor[index] = arreColores[nivel]          
        } 
        setAuxColores(auxArregloColor)
      }          
    }    
    setCambiaMarcador(true)      
    return()=>{
      setCheckEtiqSecc(false)
    }
  },[centro,poligonos,listPoligono]);


useEffect(()=>{
  window.addEventListener('resize', function() {
    if(!redimensionar){
        if(window.innerHeight<altuTamMax){
          setAlturaContenedor(window.innerHeight-165)
          }else{
              setAlturaContenedor(window.innerHeight-200)
          }
          if(window.innerWidth<anchoTamMax){
            setAnchoContenedor(window.innerWidth-200)
          }else{
            setAnchoContenedor(window.innerWidth-200)
          }
    }else{
      if(window.innerHeight<altuTamMax){
            setAlturaContenedor(window.innerHeight-200)
        }else{
            setAlturaContenedor(window.innerHeight-300)
        }

        if(window.innerWidth<anchoTamMax){
            setAnchoContenedor(window.innerWidth-510)
        }else{
            setAnchoContenedor(window.innerWidth-750)
        }
    }
});
},[alturaContenedor,anchoContenedor,anchoTamMax,altuTamMax,redimensionar])

  const onLoad =(respuesta)=> {
    setAutocomplete(respuesta);

  }

 
  const options =(numero)=> {    
    const auxiliar={  
    fillColor: auxColores[numero],
    fillOpacity: 0.3,
    strokeColor: "orange",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1}
    return auxiliar;
  }

  const options2 =(numero)=> {    
    const auxiliar={  
    fillColor: auxColores[numero],
    fillOpacity: 0.3,
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1}
    return auxiliar;
  }
  const onLoadPolygono = marker => {
    //console.log('Poligono: ', marker)
  }
  const image = { url:"marcador.svg" };
  const image2 = { url:"marcador_seleccionado.svg" };
  const image3 = { url:"marcador_poligono.svg" };

  const seleccionCordenada=(e)=>{
    //e.preventDefault()
    
    //console.log(`location[${JSON.stringify(e.latLng)}]`);    
    let aux1=parseFloat(e.latLng.lat())
    let aux2=parseFloat(e.latLng.lng())              
    let arreMarcador= { lat : aux1, lng :aux2 }
  
    setAuxMarcador(arreMarcador)
  }

  const formatoInfo=(info,auxCoord,valor)=>{    
    let auxArr=[]
    const txt=`Usuario: ${info.UsrNom}`
    const txt2=`Tel: ${info.UsrTel}`
    const txt3=`Secc:${info.SeccNum}  Tipo: ${info.TipoNom}`       
    const txt4=`Observ: ${info.Obsrv}`       
    const txt5="Dir: "+info.Dir           
    auxArr={id:info.Id, coordenada:auxCoord, texto:txt, texto2:txt2,
      texto3:txt3, texto4:txt4, texto5:txt5, valor:valor} 
    //console.log(auxArr);   
    setLeyendaMap(auxArr)
  }
  
  
  const obtnEtiqRecor=(auxRec)=>{
    const arrRec=[0,1,2,3,1,2,3,1,2,3]
    let respuesta="https://benitojuarez.sfo3.cdn.digitaloceanspaces.com/recurso/marker"
    respuesta=`${respuesta}${arrRec[auxRec.r1Id]}${arrRec[auxRec.r2Id]}${arrRec[auxRec.r3Id]}.svg`    
    return(respuesta)
  }

  const obtnEtiqComer=(auxRec)=>{
    const arrRec=[2,1]
    let respuesta="https://benitojuarez.sfo3.cdn.digitaloceanspaces.com/recurso/marker"
    respuesta=`${respuesta}${arrRec[auxRec.r1Id]}${arrRec[auxRec.r2Id]}${arrRec[auxRec.r3Id]}.svg`    
    return(respuesta)
  }

  const posicionMarcador=(e,poligono)=>{
    //e.preventDefault()    
    setCoordenada(poligono)
  }

  return (    //"AIzaSyD0QUSpmbFDJLxSl5YXdmANyrA5GQoiWWE"
  <LoadScript googleMapsApiKey={process.env.REACT_APP_G_MAP_KEY} libraries={["places"]}> 
    <GoogleMap
      id="searchbox-example"  zoom={15.5} center={centro}
      mapContainerStyle={{   width:anchoContenedor, height:alturaContenedor }}           
    >  
    {leyendaMap.length!==0?
    <CajaLeyenda leyendaMap={leyendaMap} setLeyendaMap={setLeyendaMap}  />
         
    :null }   
    { cambiaMarcador && auxPoligRevision && auxPoligRevision.length>0 ?
      auxPoligRevision.map((marcador,index) => 
      {
        if((marcador[0] !== undefined ||  marcador[0] !== null || marcador[0] !== "")
          && (marcador[1] !== undefined ||  marcador[1] !== null || marcador[1] !== "")
        ) 
        {          
          let auxCoord=generaCoordenadaDinam(marcador[1], marcador[0])                   
          return(
          <Marker
            onLoad={onLoad} icon= {image3}
            title={marcador.promNombre}
            position={ auxCoord}                                          
          />
          )
          
        }        
      })      
      :null 
    }  
    
    { seccPolEntrada !== null && seccPolEntrada.length > 0 ?  //lista de poligonos             
        <Polygon
          onLoad={onLoadPolygono} paths={[seccPolEntrada]}
          options={options2(5)}
        />
              
      :null
    }      
    { rutaPol!==null?  //lista de poligonos
      rutaPol.map((poligono,index) => 
      { 
        return(
        <Polygon
          onLoad={onLoadPolygono} paths={poligono.gps}
          options={options(index)}
        />
        )
      })      
      :null
    }     
    {checkEtiqSecc&& rutaPol!==null && rutaPol.length!==0?
      rutaPol.map((poligono) => 
      {         
        return(   
          <Marker style={{width:80+'px',height:80+'px'}}
          title={`${poligono.secc}`}   key={poligono.Id}
          position={ poligono.centro}   
          icon= {{url:`https://daduva-cartografia.sfo3.cdn.digitaloceanspaces.com/Sec/Secc${poligono.secc}.svg`}} 
       />   )
      })      
      :null
    }   
    { poligonos!==null && poligonos.length > 0 ? //marcadores graficados de la api
      poligonos.map((poligono,index) => 
      { 
        return(
        <Marker
          icon= {image} onClick={e=>posicionMarcador(e,poligono)}
          position={{lat :parseFloat(poligono.seccionLat) ,
            lng:parseFloat(poligono.seccionLon)}}
          //options={options(index)}          
        />
        )
      })      
      :null
    }       
    {listMapProm && listMapProm.length!==0 ?
        listMapProm.map((perfil,index)=>{
          const auxCoord=generaCoordenadaDinam(perfil.Lat, perfil.Lon) 
          //console.log(auxCoord);
          const aviso=perfil.Gps===0?"\nSin Coordenadas":""
          const icono=perfil.Gps=== 1 ? (perfil.StatusId===2 ? "marcador-valido.svg":(perfil.StatusId===1? "marcador-pendiente.svg":"marcador-rechazado.svg"))
          :( perfil.StatusId===2 ? "marcador-valid-snc.svg":(perfil.StatusId===1? "marcador-pend-snc.svg":"marcador-rech-snc.svg") )
          return(
            <Marker style={{width:50+'px',height:50+'px'}}
              title={`${perfil.Nom} \n${perfil.Tel} ${aviso}`}   key={index}
              position={ auxCoord}  
              icon= {icono}                   
            />)
        })
    :null}
    {listApoyos && listApoyos.length!==0 ?
        listApoyos.map((perfil,index)=>{
          const auxCoord=generaCoordenadaDinam(perfil.Lat, perfil.Lon)                     
          const icono="marcador-militante.svg"     
          const dir=perfil.Dir!==""?`\n ${perfil.Dir}`:""  
          return(
            <Marker style={{width:50+'px',height:50+'px'}}
              title={`${perfil.Obsrv} ${dir}`}    key={index}
              position={ auxCoord}  
              icon= {icono}                   
            />)
        })
      :null}
    {listRecorrido && listRecorrido.length!==0 ?
      listRecorrido.map((recorr,index)=>{
        const auxCoord=generaCoordenadaDinam(recorr.Lat, recorr.Lon)                     
        const icono="https://benitojuarez.sfo3.cdn.digitaloceanspaces.com/recurso/marker112.svg"//"marca_recorrido.svg"      
        const dir=recorr.Dir!==""?`\n ${recorr.Dir}`:"" 
        return(
        <Marker style={{width:50+'px',height:50+'px'}}
          title={`${recorr.TipoNom} \n${recorr.Obsrv} ${dir}`}   key={index}
          position={ auxCoord}  onClick={()=>formatoInfo(recorr,auxCoord,true)} 
          icon= {obtnEtiqRecor(recorr)}                   
        />)
      })
    :null}
     {listComercio && listComercio.length!==0 ?
      listComercio.map((comer,index)=>{
      const auxCoord=generaCoordenadaDinam(comer.Lat, comer.Lon)                               
      const dir=comer.Dir!==""?`\n ${comer.Dir}`:""
      return(
      <Marker style={{width:50+'px',height:50+'px'}}
        title={`${comer.TipoNom} \n${comer.Obsrv} ${dir}`}   key={index}
        position={ auxCoord}  
        icon= {obtnEtiqComer(comer)}    onClick={()=>formatoInfo(comer,auxCoord,true,1)}                  
      />)
    })
    :null}
  </GoogleMap>
</LoadScript>  
);
} 